'use client';

import React, {ReactNode} from 'react';
import {StyledRichTextLink} from '@/components/contentful/RichTextRenderer.styles';

type AssetDownloadLinkProps = {
  href: string;
  useSecondaryLinkColor?: boolean;
  children: ReactNode;
};

const AssetDownloadLink: React.FC<AssetDownloadLinkProps> = ({href, useSecondaryLinkColor, children}) => {
  return (
    <StyledRichTextLink
      useSecondaryLinkColor={useSecondaryLinkColor}
      href={href}
      target='_blank'
      rel='noopener noreferrer'
    >
      {children}
    </StyledRichTextLink>
  );
};

export default AssetDownloadLink;
